"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)(() => ({
    root: {
        marginTop: '2pt',
        marginBottom: '2pt',
        paddingTop: '0',
        paddingBottom: '0',
        height: 22,
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    item: {
        paddingTop: '2pt',
        paddingBottom: '2pt',
    },
    select: {
        paddingRight: '0 !important',
    },
    input: {
        '&::before': {
            border: 0,
        },
        height: 22,
        width: '100%',
        verticalAlign: 'top',
        // classes cannot be send to wrapping Input, therefore we need to use direct override
        '&.Mui-disabled': {
            backgroundColor: 'inherit',
            color: 'inherit',
        },
        '& .MuiSelect-icon.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.54)',
        },
    },
    endAdornment: {
        marginLeft: 4,
    },
    icon: {
        padding: 1,
        marginRight: '2pt',
    },
    iconOpened: {
        transform: 'rotate(180deg)',
    },
}));
//# sourceMappingURL=select-styles.js.map